//----------------------
// <auto-generated>
//     Split from WebApiController.ts
//     Regenerate with: node scripts/splitWebApiController.js
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming


import { PosClientBase, PosClientConfig, throwException } from './base';
import type { UiCurrency } from './types';


export interface IMoneyClient {

    getConvertedMoneyAmount(valuesToConvert: { [key: string]: number; }, toCurrencyCode: string | undefined): Promise<number>;

    getAvailableCurrencies(): Promise<UiCurrency[]>;
}

export class MoneyClient extends PosClientBase implements IMoneyClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getConvertedMoneyAmount(valuesToConvert: { [key: string]: number; }, toCurrencyCode: string | undefined, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Money/GetConvertedMoneyAmount?";
        if (toCurrencyCode === null)
            throw new Error("The parameter 'toCurrencyCode' cannot be null.");
        else if (toCurrencyCode !== undefined)
            url_ += "toCurrencyCode=" + encodeURIComponent("" + toCurrencyCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(valuesToConvert);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConvertedMoneyAmount(_response);
        });
    }

    protected processGetConvertedMoneyAmount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getAvailableCurrencies(signal?: AbortSignal | undefined): Promise<UiCurrency[]> {
        let url_ = this.baseUrl + "/api/Money/GetAvailableCurrencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableCurrencies(_response);
        });
    }

    protected processGetAvailableCurrencies(response: Response): Promise<UiCurrency[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UiCurrency[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UiCurrency[]>(null as any);
    }
}
